<template>
<div>
    <section>
        <user-select v-model="searchedUser" placeholder="Spieler suchen" type="all" @input="searchUser" />
    </section>
    <section v-if="running_tournaments.length > 0">
        <h2>Turniere</h2>
        <router-link :to="`tournament/${inv.tournament_id}`" v-for="inv in running_tournaments" :key="inv.id" class="item">
            <img src="images/tournament-dark.png" class="tournament">
            <h3>
                {{ inv.tournament.name }}
            </h3>
            <small>
                {{ inv.tournament.status | tournament_status }}
            </small>
        </router-link>
    </section>

    <section v-if="invitations.length > 0">
        <h2>Erhaltene Anfragen</h2>
        <div v-for="req in invitations" class="item">
            <template v-if="req.kind == 'match'">
                <dp :who="req.player_a" />
                <h3>{{ req.player_a.firstname + ' ' + req.player_a.lastname }}</h3>
                 <a href="#" @click.prevent="acceptMatch(req)" class="btn btn-secondary">Akzeptieren</a>
            </template>
            <template v-else>
                <img src="images/tournament-dark.png" class="tournament">
                <h3>{{ req.tournament.name }}</h3>
                <a href="#" @click.prevent="acceptTournament(req)" class="btn btn-secondary">Akzeptieren</a>
            </template>
        </div>
    </section>

    <section v-if="friendRequests.length > 0">
        <h2>Freundschaftsanfragen</h2>
        <div v-for="req in friendRequests" v-if="req.user_b.friendship !== null" class="item">
            <template>
                <dp :who="req.user_b" />
                <h3><user-link :who="req.user_b" /></h3>
                <friendship-button :who="req.user_b"/>
            </template>
        </div>
    </section>

    <section v-if="myMatches.length > 0">
        <h2>Geplante Spiele</h2>
        <div v-for="req in myMatches" class="item">
            <template v-if="!req.tournament">
                <dp :who="req.player_a_id == user.id ? req.player_b : req.player_a" />
                <h3 v-if="req.player_a_id == user.id">
                    {{ req.player_b.firstname + ' ' + req.player_b.lastname }}
                </h3>
                <h3 v-else>
                    {{ req.player_a.firstname + ' ' + req.player_a.lastname }}
                </h3>

                <a href="#" @click.prevent="submitScore(req)" v-if="req.status == 'ready'" class="btn btn-secondary">Spielen</a>
                <a v-else-if="req.status == 'requested'"
                   href="#"
                   @click.prevent="retractMatchRequest(req)"
                   class="btn btn-secondary">
                   Anfrage zurückziehen
               </a>
                <small v-else-if="req.status == 'confirming' && (req.scored_by == 'a' && req.player_a_id == user.id || req.scored_by == 'b' && req.player_b_id == user.id)">
                    Ergebnis wird geprüft
                </small>
                <a href="#" @click.prevent="submitScore(req)" v-else class="btn btn-secondary">
                    Ergebnis prüfen
                </a>
            </template>
            <template v-else>
                <dp :who="req.player_a_id == user.id ? req.player_b : req.player_a" />
                <h3 v-if="req.player_a_id == user.id">
                    {{ req.player_b.firstname + ' ' + req.player_b.lastname }}
                </h3>
                <h3 v-else>
                    {{ req.player_a.firstname + ' ' + req.player_a.lastname }}
                </h3>
                <small>
                    Teil eines Turniers
                    <template v-if="req.type != 'regular'">
                        (Ausscheidungsphase)
                    </template>
                </small>

                <template v-if="req.status == 'ready'">
                    <a href="#" @click.prevent="submitScore(req)" v-if="req.tournament.status == 'in-progress'" class="btn btn-secondary">Spielen</a>
                    <small v-else>Warten auf Turnierbeginn</small>
                </template>
                <small v-else-if="req.status == 'confirming' && (req.scored_by == 'a' && req.player_a_id == user.id || req.scored_by == 'b' && req.player_b_id == user.id)">
                    Ergebnis wird geprüft
                </small>
                <a href="#" @click.prevent="submitScore(req)" v-else class="btn btn-secondary">
                    Ergebnis prüfen
                </a>
            </template>
        </div>
    </section>

    <section class="activities">
        <header>
            <h2>Benachrichtigungen</h2>
            <div>
                <router-link to="/notifications" class="btn-secondary">
                    Archiv
                </router-link>
                <a href="#" @click.prevent="clearNotifications()" class="btn-secondary" v-if="notifications.length > 0">
                    Als gelesen markieren
                </a>
            </div>
        </header>
        <notifications :notifications="notifications" />
    </section>

    <section class="activities">
        <header>
            <h2>Aktivität</h2>
            <div>
                <router-link to="/post" class="btn-primary post">
                    Posten
                </router-link>
            </div>
        </header>
        <timeline :activities="activities" />
        <infinite-loading @infinite="scrollHandler">
            <span slot="no-results">
                Hier ist noch nichts los :(<br>
                Füge Freunde hinzu oder trage Spiele ein, um das zu ändern!
            </span>
            <span slot="no-more">
                Ende der Aktivitäten
            </span>
        </infinite-loading>
    </section>
</div>
</template>

<script>
import _ from 'underscore'
import infiniteLoading from 'vue-infinite-loading'
import dp from 'components/dp.vue'
import timeline from 'components/timeline.vue'
import notifications from 'components/notifications.vue'
import userSelect from 'components/user-select.vue'
import friendshipButton from 'components/friendship-button.vue'
import userLink from 'components/user-link.vue'
import base from 'base.vue'

export default {
    mixins: [ base ],
    components: { dp, timeline, notifications, infiniteLoading, userSelect, friendshipButton, userLink },
    data () {
        return {
            searchedUser: null,
            matches: [],
            tournaments: [],
            activities: [],
            notifications: [],
            notificationsFetchedAt: null,
            friendRequests: []
        }
    },
    computed: {
        running_tournaments () {
            return _.filter(this.tournaments, x => {
                return x.tournament.status == 'in-progress'
            })
        },
        invitations () {
            var m = _.filter(this.matches, x => {
                return x.player_b_id == window.store.state.user.id && x.status == 'requested'
            })

            var t = _.filter(this.tournaments, x => {
                return !x.accepted
            })

            return _.sortBy(m.concat(t), x => {
                return x.created_at
            })
        },
        myMatches () {
            var m = _.filter(this.matches, x => {
                return (x.status == 'ready' && x.player_a_id !== null && x.player_b_id !== null) 
                    || x.status == 'confirming' 
                    || (x.status == 'requested' && x.player_a_id == window.store.state.user.id)
            })

            return _.sortBy(m, x => {
                return x.created_at
            })
        }
    },
    methods: {
        fetchData () {
            const that = this

            return this.$api.get('home')
            .then(response => {
                const matches = response.data.matches
                _.each(matches, x => { x.kind = 'match' })
                that.matches = matches

                const tournaments = response.data.invitations
                _.each(tournaments, x => { x.kind = 'tournament' })
                that.tournaments = tournaments

                that.activities = response.data.timeline

                that.notifications = response.data.notifications
                that.notificationsFetchedAt = new Date

                const friendRequests = response.data.friend_requests
                _.each(friendRequests, r => { r.user_b.friendship = 'requested' })
                that.friendRequests = friendRequests
            })
        },
        scrollHandler ($state) {
            // Note that the first batch of activities is loaded by `fetchData()`

            // No activities found - empty list
            if (this.activities.length == 0) {
                $state.complete()
                return
            }

            const that = this
            this.$api.get('timeline', {
                after: _.last(this.activities).id
            })
            .then(response => {
                that.activities = that.activities.concat(response.data)

                // Call `loaded()` at least once if the list is not empty
                // (`fetchData()` did load one or more activities)
                $state.loaded()

                // No further activities found - end of list
                if (response.data.length == 0) {
                    $state.complete()
                }
            })
        },
        acceptTournament (inv) {
            this.$api.post('tournament/' + inv.tournament_id + '/accept')
            .then(response => {
                inv.accepted = 1
                inv.tournament.num_players_accepted++

                // TODO: Load matches
                if (inv.tournament.num_players_accepted == inv.tournament.num_players) {
                    inv.tournament.status = 'in-progress'
                }
            })
        },
        acceptMatch (req) {
            this.$api.post('match/' + req.id + '/accept')
            .then(response => {
                req.status = 'ready'
            })
        },
        retractMatchRequest (req) {
            const that = this
            this.$api.post(`match/${req.id}/retract`)
            .then(response => {
                that.matches = _.filter(that.matches, m => m.id != req.id)
            })
        },
        submitScore (req) {
            router.push('/match/' + req.id)
        },
        clearNotifications () {
            this.$api.post('notifications/clear', {
                until: this.notificationsFetchedAt
            })
            .then(response => {
                this.notifications = [ ]
            })
        },
        searchUser (user) {
            if (user !== null) {
                this.$router.push(`profile/${user.id}`)
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// home.vue?3e06a1ca